import axios from 'axios';
import { ErrorMessage, Field, Form, Formik, useField } from 'formik';
import fileDownload from 'js-file-download';
import Moment from 'moment';
import { useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { BiInfoCircle } from 'react-icons/bi';
import { FaFileDownload, FaSearchLocation, FaTrash } from 'react-icons/fa';
import InputMask from 'react-input-mask';
//import Select from 'react-select';
import { Tabs } from '@welm/react-tabs';
import { DatePicker, Select } from 'antd';
import locale from 'antd/es/date-picker/locale/pt_BR';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { BiChevronDown } from "react-icons/bi";
import AsyncSelec from 'react-select';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { v4 as uuid } from 'uuid';
import { useSystemContext } from '../Context/SystemContext';
import { cn } from '../helper/utils';

function deepRecursiveParseData(data, field) {
    if (!field) return '';
    if (field.indexOf('.') > 0) {
        let fields = field.split('.');
        let firstField = fields.shift();
        return deepRecursiveParseData(data[firstField], fields.join('.'));
    } else {
        if (!data) return '';
        return data[field];
    }
}


export const DropboxDBInput = ({ displaySelectField, url, externalRef, onSelectedOption, ...rest }, ref) => {
    const System = useSystemContext();
    const [opcoes, setOpcoes] = useState([]);
    const [internalUrl, setInternalUrl] = useState(url ?? '');
    const SelectedOption = onSelectedOption ? onSelectedOption : () => null;

    useImperativeHandle(externalRef, () => ({
        changeUrl
    }));


    //const carregarOpcoes = async (inputValue) => {
    const carregarOpcoes = useCallback(async () => {
        try {
            const response = await System.apiGet(internalUrl);
            let opcoesFormatadas = response.data.map((item) => ({
                label: item[displaySelectField],
                value: item[displaySelectField],
                id: item._id,
            }));
            setOpcoes(opcoesFormatadas);
            return opcoesFormatadas;
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            return [];
        }
        // eslint-disable-next-line
    }, [internalUrl]);

    useEffect(() => {
        carregarOpcoes();
    }, [carregarOpcoes]);

    function changeUrl(newUrl) {
        setInternalUrl(newUrl);
        carregarOpcoes();
    }


    return (
        <div className={cn(`mt-1 pl-2 pr-2 w-full`, rest.className)}>
            <label htmlFor={rest.name} className="block">
                {rest.label}
            </label>
            <Field name={rest.name}>
                {({ field, form, meta }) => {
                    let selectedOption = { value: field.value, label: field.value };

                    return (
                        <AsyncCreatableSelect
                            style={{ display: 'block' }}
                            className={`block w-full rounded-md px-1 ${rest.disabled ? 'bg-gray-300' : ''}`}
                            value={selectedOption}
                            onChange={(newValue, actionMeta) => {
                                //console.log('onChange', newValue, actionMeta);
                                if (actionMeta.action === 'clear') {
                                    form.setFieldValue(rest.name, null);
                                    SelectedOption(null);
                                } else {
                                    form.setFieldValue(rest.name, newValue.value);
                                    SelectedOption(newValue);
                                }
                            }}
                            onCreateOption={(inputValue) => {
                                selectedOption = { value: inputValue, label: inputValue, id: null };
                                form.setFieldValue(rest.name, inputValue);
                            }}
                            placeholder="Selecione..."
                            createOptionPosition='first'
                            formatCreateLabel={(inputValue) => `Novo "${inputValue}"`}
                            isClearable
                            cacheOptions
                            allowCreateWhileLoading
                            defaultOptions={opcoes}
                            loadOptions={carregarOpcoes}
                        />
                    );
                }}
            </Field>
            <ErrorMessage className="text-xs text-red-400" name={rest.name} component="div" />
        </div>
    );
};


export const DropDownGroupInput = ({ name, url = '/genero-alimento-withsub', groupName = "generoAlimento", subGroupList = "subGeneros", subGroupField = "subGeneroAlimento", className, label = 'label', information = '' }) => {
    const System = useSystemContext();
    const [options, setOptions] = useState([]);
    const { Option, OptGroup } = Select;
    const carregarOpcoes = useCallback(async () => {
        try {
            const response = await System.apiGet(url);
            if (response.status === 200) {
                let opcoesFormatadas = response.data.map((item) => ({
                    label: item[groupName],
                    options: item[subGroupList].map((subitem) => ({
                        label: subitem[subGroupField],
                        value: subitem._id,
                    })),
                }));
                setOptions(opcoesFormatadas);
            }
            return;
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            return [];
        }
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        carregarOpcoes();
    }, [carregarOpcoes]);


    //const [field, meta, helper] = useField(name);


    return (
        <div className={cn(`mt-1 pl-2 pr-2 w-full relative`, className)}>
            <label className="block">
                <div className='inline-flex'>
                    {label}
                    {information && <BiInfoCircle title={information} size={14} className='mt-1 ml-1 text-blue-700' />}
                </div>

            </label>
            <Field name={name}>
                {({ field, form }) => {
                    return (
                        <Select className="w-full" name={name} value={field.value} onChange={(id) => {
                            form.setFieldValue(name, id);
                        }
                        }>
                            {options.map(grupo => (
                                <OptGroup key={grupo.label} label={grupo.label}>
                                    {grupo.options.map(opcao => (
                                        <Option key={opcao.value} value={opcao.value}>
                                            {opcao.label}
                                        </Option>
                                    ))}
                                </OptGroup>
                            ))}
                        </Select>
                    );
                }}
            </Field>

            <ErrorMessage className="text-xs text-red-400" name={name} component="div" />
        </div >
    );

}


export const DropDownProcessosinput = ({ name, className, label = 'label' }) => {
    const System = useSystemContext();
    const [options, setOptions] = useState([]);
    const carregarOpcoes = useCallback(async () => {
        try {
            const response = await System.apiGet('/processwithsub');
            //console.log('response', response.data);
            let opcoesFormatadas = response.data.map((item) => ({
                label: item['processo'],
                options: item.subprocessos.map((subitem) => ({
                    label: subitem['subprocesso'],
                    value: subitem._id,
                })),
            }));
            setOptions(opcoesFormatadas);
            return;
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            return [];
        }
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        carregarOpcoes();
    }, [carregarOpcoes]);


    const [field, meta, helpers] = useField(name);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    let selectedOptions = field.value ?? [];
    const selectedCount = selectedOptions.length;

    const toggleOption = (option) => {
        if (selectedOptions.includes(option.value)) {
            selectedOptions = selectedOptions.filter((item) => item !== option.value);
        } else {
            selectedOptions.push(option.value);
        }
        helpers.setValue(selectedOptions);
    };

    const isSelected = (option) => selectedOptions.includes(option.value);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className={cn(`mt-1 pl-2 pr-2 w-full relative`, className)} ref={dropdownRef}>
            <label htmlFor={name} className="block">
                {label}
            </label>

            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="w-full px-2 py-2 text-left bg-white border border-gray-300 rounded-md shadow-sm "
            >
                <span className="block truncate">
                    {selectedCount > 0 ? `${selectedCount} Selecionados` : '<Lista Vazia>'}
                </span>
                <span className="absolute inset-y-0 right-0 flex items-center pr-2 mt-4 pointer-events-none">
                    <BiChevronDown className="w-5 h-5 " />
                </span>
            </button>

            {isOpen && (
                <div className="absolute z-10 w-full mt-1 overflow-auto bg-white border border-gray-300 rounded-md shadow-lg max-h-60">
                    {options.map((group, groupIndex) => (
                        <div key={groupIndex}>
                            <div className="px-4 py-2 font-semibold bg-gray-100">{group.label}</div>
                            {group.options.map((option, optionIndex) => (
                                <label
                                    key={optionIndex}
                                    className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
                                >
                                    <input
                                        type="checkbox"
                                        checked={isSelected(option)}
                                        onChange={() => toggleOption(option)}
                                        className="w-5 h-5 text-blue-600 form-checkbox"
                                    />
                                    <span className="ml-2">{option.label}</span>
                                </label>
                            ))}
                        </div>
                    ))}
                </div>
            )}

            {meta.touched && meta.error && (
                <div className="mt-1 text-sm text-red-500">{meta.error}</div>
            )}
        </div>
    );

}

export const Input = ({ type, name, label, error, className, defaultValue, information = '', pattern, ...rest }) => {
    return (
        <div className={cn(`mt-1 pl-2 pr-2 w-full`, className)}>
            <Field name={name}>
                {({
                    field, // { name, value, onChange, onBlur }
                    form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                    meta,
                }) => (
                    <>
                        <label htmlFor={name} className="block">
                            <div className='inline-flex'>
                                {label}
                                {information && <BiInfoCircle title={information} size={14} className='mt-1 ml-1 text-blue-700' />}
                            </div>
                        </label>
                        <input
                            {...field}
                            name={name}
                            value={field.value || ''}
                            pattern={pattern}
                            type={type ?? 'text'}
                            className={`block w-full rounded-md border px-1 py-2 ${meta.touched && meta.error ? 'border-red-500' : ''} ${rest.disabled ? 'bg-gray-300' : ''}`}
                            {...rest}
                        />
                    </>
                )}
            </Field>
            <ErrorMessage className="text-xs text-red-400" name={name} component="div" />
        </div>
    );
};

export const InputFloat = ({ name, label, className, information = '', decimals = 2, allowNegative = false, defaultValue = 0, ...rest }) => {
    const sanitize = (raw) => {
        if (raw === null || raw === undefined) return '';
        let str = String(raw).replace(',', '.').replace(/[^0-9.-]/g, '');

        if (allowNegative) {
            const neg = str.startsWith('-');
            str = str.replace(/-/g, '');
            if (neg) str = '-' + str;
        } else {
            str = str.replace(/-/g, '');
        }

        const firstDot = str.indexOf('.');
        if (firstDot !== -1) {
            str = str.slice(0, firstDot + 1) + str.slice(firstDot + 1).replace(/\./g, '');
        }

        if (decimals === 0) {
            str = str.split('.')[0];
        } else if (firstDot !== -1) {
            const [intPart, decPart = ''] = str.split('.');
            str = intPart + '.' + decPart.slice(0, decimals);
        }

        return str;
    };

    return (
        <div className={cn(`mt-1 pl-2 pr-2 w-full`, className)}>
            <Field name={name}>
                {({ field, form, meta }) => {
                    const isEmpty = field.value === '' || field.value === null || field.value === undefined;
                    const displayValue = isEmpty ? Number(defaultValue).toFixed(decimals) : field.value;

                    return (
                        <>
                            <label htmlFor={name} className="block">
                                <div className='inline-flex'>
                                    {label}
                                    {information && <BiInfoCircle title={information} size={14} className='mt-1 ml-1 text-blue-700' />}
                                </div>
                            </label>
                            <input
                                name={name}
                                value={displayValue}
                                onChange={(e) => form.setFieldValue(name, sanitize(e.target.value))}
                                onBlur={(e) => {
                                    const clean = sanitize(e.target.value);
                                    const fallback = Number(Number(defaultValue).toFixed(decimals));
                                    const num = clean === '' || clean === '-' ? fallback : parseFloat(clean);
                                    form.setFieldValue(name, Number.isNaN(num) ? fallback : Number(num.toFixed(decimals)));
                                    field.onBlur(e);
                                }}
                                inputMode={decimals > 0 ? 'decimal' : 'numeric'}
                                type="text"
                                className={`block w-full rounded-md border px-1 py-2 ${meta.touched && meta.error ? 'border-red-500' : ''} ${rest.disabled ? 'bg-gray-300' : ''}`}
                                {...rest}
                            />
                        </>
                    );
                }}
            </Field>
            <ErrorMessage className="text-xs text-red-400" name={name} component="div" />
        </div>
    );
};

export const InputCurrency = ({ name, label, error, className, defaultValue, ...rest }) => {
    const currencyMask = (value) => {
        // Remove qualquer caractere que não seja dígito
        const numericValue = value.replace(/\D/g, '');
        // Converte para número e divide por 100 para obter os centavos
        const numberValue = parseFloat(numericValue) / 100;
        // Formata como moeda
        return numberValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    return (
        <div className={cn(`mt-1 pl-2 pr-2 w-full`, className)}>
            <Field name={name}>
                {({
                    field,
                    form: { setFieldValue },
                    meta,
                }) => {
                    const handleChange = (event) => {
                        const { value } = event.target;
                        const formattedValue = currencyMask(value);
                        setFieldValue(name, formattedValue);
                    };

                    return (
                        <>
                            <label htmlFor={name} className="block">
                                {label}
                            </label>
                            <input
                                {...field}
                                name={name}
                                value={field.value || ''}
                                type="text"
                                onChange={handleChange}
                                className={`block w-full rounded-md border px-1 py-2 ${meta.touched && meta.error ? 'border-red-500' : ''
                                    } ${rest.disabled ? 'bg-gray-300' : ''}`}
                                {...rest}
                            />
                        </>
                    );
                }}
            </Field>
            <ErrorMessage className="text-xs text-red-400" name={name} component="div" />
        </div>
    );
};


export const AttachmentInput = ({
    type,
    name,
    label,
    className,
    callParentCommit = () => { },
    canDownload = true,
    canEdit = true,
    canInsert = true,
    canDelete = true,
    perms = null,
    onChange = null,
    ...rest
}) => {
    const System = useSystemContext();

    // permissoes
    const _canEdit = perms ? System.methods.getUserRule(`alterar${perms}`) : typeof canEdit === 'boolean' ? canEdit : true;

    const _canInsert = perms ? System.methods.getUserRule(`alterar${perms}`) : typeof canInsert === 'boolean' ? canInsert : true;

    const _canDelete = perms ? System.methods.getUserRule(`deletar${perms}`) : typeof canDelete === 'boolean' ? canDelete : true;

    async function _downloadFile(file) {
        try {
            const fileinfo = await System.apiGetFileInfo(file);
            if (!fileinfo?.filename) {
                System.methods.notificationError('Erro no arquivo');
                return;
            }
            const Ext = fileinfo.filename.split('.').pop();
            const response = await System.apiGetRawFile(file);
            if (response.status === 200) {
                fileDownload(response.data, file + '.' + Ext);
            } else {
                System.methods.notificationError('Erro no arquivo');
            }
        } catch (error) {
            console.log('Erro no arquivo', error);
            System.methods.notificationError('Erro no arquivo');
        }
    }
    async function _deleteFile(file) {
        return await System.apiDelete(`/simpleupload/${file}`).then(async (response) => {
            if (response.status === 200) {
                return null;
            } else {
                console.log('Erro deletando anexo');
                return null;
            }
        });
    }
    async function _uploadFile(file, document) {
        let newForm = new FormData();
        newForm.append('arquivo', file);
        newForm.append('document', document);
        System.methods.Loading(true);
        return await System.apiPost('/simpleupload', newForm).then(async (response) => {
            System.methods.Loading(false);
            if (response.status === 200) {
                return response.data._id;
            }
            return null;
        });
    }
    return (
        <div className={cn(`mt-1 pl-2 pr-2 w-full`, className)}>
            <label htmlFor={name} className="block">
                {label}
            </label>
            <Field name={name}>
                {({ field, form: { touched, errors, setErrors, setFieldValue, initialValues }, meta }) => (
                    <div className="inline-flex">
                        {field.value && (
                            <div className="inline-flex ">
                                {canDownload && field.value.length === 24 && <FaFileDownload className="w-8 h-8 mt-2 mr-2 cursor-pointer" title="Baixar arquivo" onClick={() => _downloadFile(field.value)} />}
                                {_canDelete && field.value.length === 24 && (
                                    <FaTrash
                                        className="w-8 h-8 mt-2 mr-2 cursor-pointer"
                                        title="Excluir Arquivo Anexo"
                                        type="submit"
                                        onClick={async () => {
                                            await setFieldValue(name, await _deleteFile(field.value));
                                            callParentCommit();
                                            if (onChange) onChange(null);
                                        }}
                                    />
                                )}
                            </div>
                        )}
                        {_canEdit && _canInsert && (
                            <input
                                filename={field.value}
                                type="file"
                                className={`block w-full rounded-md border px-1 py-2 `}
                                {...rest}
                                onChange={async (e) => {
                                    const newFileID = await _uploadFile(e.target.files[0], initialValues.document);
                                    setFieldValue(name, newFileID);
                                    if (onChange) {
                                        onChange(newFileID);
                                    }
                                }}
                            />
                        )}
                    </div>
                )}
            </Field>
            <ErrorMessage className="text-xs text-red-400" name={name} component="div" />
        </div >
    );
};

export const InputAvatar = ({
    crewId,
    label,
    width = 128,
    height = 128,
    className,
    information = '',
    onChange = null,
}) => {
    const System = useSystemContext();
    const [hasAvatar, setHasAvatar] = useState(false);
    const [editingSrc, setEditingSrc] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0, size: 0 });
    const [imgSize, setImgSize] = useState({ w: 0, h: 0 });
    const [dragging, setDragging] = useState(null);
    const imgRef = useRef(null);
    const fileInputRef = useRef(null);
    const previewObjectUrlRef = useRef(null);

    const aspect = width / height;

    async function _uploadBlob(blob) {
        if (!crewId) {
            console.log('🔴 InputAvatar: crewId não informado');
            return false;
        }
        const newForm = new FormData();
        newForm.append('arquivo', new File([blob], 'avatar.png', { type: 'image/png' }));
        System.methods.Loading(true);
        const response = await System.apiPost(`/avatar/${crewId}`, newForm);
        System.methods.Loading(false);
        if (response?.status === 200) {
            console.log('🟢 InputAvatar upload OK', response.data);
            return true;
        }
        console.log('🔴 InputAvatar upload falhou', response?.status, response?.data);
        return false;
    }

    async function _deleteAvatar() {
        if (!crewId) return false;
        const response = await System.apiDelete(`/avatar/${crewId}`);
        if (response?.status !== 200) {
            console.log('Erro deletando avatar', response?.status);
            return false;
        }
        return true;
    }

    function _onFilePicked(e) {
        const file = e.target.files?.[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => setEditingSrc(reader.result);
        reader.readAsDataURL(file);
        e.target.value = '';
    }

    function _onImageLoaded(e) {
        const img = e.target;
        const naturalW = img.naturalWidth;
        const naturalH = img.naturalHeight;
        setImgSize({ w: naturalW, h: naturalH });
        const initial = Math.min(naturalW, naturalH * aspect);
        const cropW = initial;
        const cropH = initial / aspect;
        setCrop({
            x: (naturalW - cropW) / 2,
            y: (naturalH - cropH) / 2,
            size: cropW,
        });
    }

    function _displayScale() {
        if (!imgRef.current || !imgSize.w) return 1;
        return imgRef.current.clientWidth / imgSize.w;
    }

    function _onMouseDown(mode, e) {
        e.preventDefault();
        setDragging({
            mode,
            startX: e.clientX,
            startY: e.clientY,
            origCrop: { ...crop },
        });
    }

    function _onMouseMove(e) {
        if (!dragging) return;
        const scale = _displayScale();
        const dx = (e.clientX - dragging.startX) / scale;
        const dy = (e.clientY - dragging.startY) / scale;
        const { origCrop } = dragging;
        let next = { ...origCrop };
        const cropH = origCrop.size / aspect;
        if (dragging.mode === 'move') {
            next.x = Math.max(0, Math.min(imgSize.w - origCrop.size, origCrop.x + dx));
            next.y = Math.max(0, Math.min(imgSize.h - cropH, origCrop.y + dy));
        } else if (dragging.mode === 'resize') {
            const delta = Math.max(dx, dy);
            const maxSize = Math.min(imgSize.w - origCrop.x, (imgSize.h - origCrop.y) * aspect);
            next.size = Math.max(20, Math.min(maxSize, origCrop.size + delta));
        }
        setCrop(next);
    }

    function _onMouseUp() {
        setDragging(null);
    }

    useEffect(() => {
        if (!dragging) return;
        window.addEventListener('mousemove', _onMouseMove);
        window.addEventListener('mouseup', _onMouseUp);
        return () => {
            window.removeEventListener('mousemove', _onMouseMove);
            window.removeEventListener('mouseup', _onMouseUp);
        };
        // eslint-disable-next-line
    }, [dragging]);

    async function _confirmCrop() {
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(imgRef.current, crop.x, crop.y, crop.size, crop.size / aspect, 0, 0, width, height);
        const blob = await new Promise((res) => canvas.toBlob(res, 'image/png'));
        const ok = await _uploadBlob(blob);
        if (!ok) {
            setEditingSrc(null);
            return;
        }
        setHasAvatar(true);
        await _loadPreview();
        if (onChange) onChange(true);
        setEditingSrc(null);
    }

    async function _remove() {
        const ok = await _deleteAvatar();
        if (!ok) return;
        if (previewObjectUrlRef.current) {
            URL.revokeObjectURL(previewObjectUrlRef.current);
            previewObjectUrlRef.current = null;
        }
        setPreviewUrl(null);
        setHasAvatar(false);
        if (onChange) onChange(false);
    }

    async function _loadPreview() {
        if (!crewId) return;
        const meta = await System.apiGet(`/avatar/${crewId}`);
        if (meta?.status !== 200 || !meta.data?._id) {
            if (previewObjectUrlRef.current) {
                URL.revokeObjectURL(previewObjectUrlRef.current);
                previewObjectUrlRef.current = null;
            }
            setPreviewUrl(null);
            setHasAvatar(false);
            return;
        }
        const fileId = meta.data._id;
        const raw = await System.apiGetRawFile(fileId);
        if (raw?.status === 200) {
            if (previewObjectUrlRef.current) URL.revokeObjectURL(previewObjectUrlRef.current);
            const url = URL.createObjectURL(raw.data);
            previewObjectUrlRef.current = url;
            setPreviewUrl(url);
            setHasAvatar(true);
        }
    }

    useEffect(() => {
        _loadPreview();
        // eslint-disable-next-line
    }, [crewId]);

    useEffect(() => {
        const previewObjectUrl = previewObjectUrlRef;
        return () => {
            if (previewObjectUrl.current) URL.revokeObjectURL(previewObjectUrl.current);
        };
    }, []);

    const disabled = !crewId;

    return (
        <div className={cn(`mt-1 pl-2 pr-2`, className)}>
            <label className="block">
                <div className="inline-flex">
                    {label}
                    {information && <BiInfoCircle title={information} size={14} className="mt-1 ml-1 text-blue-700" />}
                </div>
            </label>
            <div>
                <div
                    className="flex items-center justify-center overflow-hidden border border-gray-300 rounded-md bg-gray-50"
                    style={{ width, height }}
                >
                    {hasAvatar && previewUrl ? (
                        <img src={previewUrl} alt="avatar" style={{ width, height, objectFit: 'cover' }} />
                    ) : (
                        <span className="text-xs text-gray-400">
                            {disabled ? 'Salve o cadastro primeiro' : 'Sem imagem'}
                        </span>
                    )}
                </div>
                <div className="inline-flex gap-2 mt-2">
                    <button
                        type="button"
                        disabled={disabled}
                        className={`px-2 py-1 text-xs text-white rounded-md ${disabled ? 'bg-gray-300 cursor-not-allowed' : 'bg-amarelo-eq hover:text-yellow-300'}`}
                        onClick={() => fileInputRef.current?.click()}
                    >
                        {hasAvatar ? 'Trocar' : 'Selecionar'}
                    </button>
                    {hasAvatar && (
                        <button
                            type="button"
                            className="px-2 py-1 text-xs text-white bg-gray-600 rounded-md hover:text-yellow-300"
                            onClick={_remove}
                        >
                            Remover
                        </button>
                    )}
                </div>
                <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={_onFilePicked}
                />
                {editingSrc && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
                        <div className="bg-white rounded-md p-4 max-w-3xl max-h-[90vh] overflow-auto">
                            <div className="mb-2 text-sm">Arraste a área para escolher o recorte. Saída: {width}×{height}px.</div>
                            <div className="relative inline-block select-none" style={{ maxWidth: '70vw' }}>
                                <img
                                    ref={imgRef}
                                    src={editingSrc}
                                    alt="crop"
                                    onLoad={_onImageLoaded}
                                    draggable={false}
                                    style={{ maxWidth: '70vw', maxHeight: '60vh', display: 'block' }}
                                />
                                {imgSize.w > 0 && (
                                    <>
                                        <div
                                            className="absolute inset-0 pointer-events-none"
                                            style={{
                                                boxShadow: `0 0 0 9999px rgba(0,0,0,0.5)`,
                                                clipPath: `polygon(
                                                    0 0, 100% 0, 100% 100%, 0 100%, 0 0,
                                                    ${crop.x * _displayScale()}px ${crop.y * _displayScale()}px,
                                                    ${(crop.x + crop.size) * _displayScale()}px ${crop.y * _displayScale()}px,
                                                    ${(crop.x + crop.size) * _displayScale()}px ${(crop.y + crop.size / aspect) * _displayScale()}px,
                                                    ${crop.x * _displayScale()}px ${(crop.y + crop.size / aspect) * _displayScale()}px,
                                                    ${crop.x * _displayScale()}px ${crop.y * _displayScale()}px
                                                )`,
                                            }}
                                        />
                                        <div
                                            className="absolute border-2 border-white cursor-move"
                                            style={{
                                                left: crop.x * _displayScale(),
                                                top: crop.y * _displayScale(),
                                                width: crop.size * _displayScale(),
                                                height: (crop.size / aspect) * _displayScale(),
                                            }}
                                            onMouseDown={(e) => _onMouseDown('move', e)}
                                        >
                                            <div
                                                className="absolute bottom-0 right-0 w-3 h-3 bg-white border border-gray-700 cursor-nwse-resize"
                                                style={{ transform: 'translate(50%, 50%)' }}
                                                onMouseDown={(e) => { e.stopPropagation(); _onMouseDown('resize', e); }}
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="flex justify-end gap-2 mt-3">
                                <button
                                    type="button"
                                    className="px-3 py-1 bg-gray-300 rounded-md hover:bg-gray-400"
                                    onClick={() => setEditingSrc(null)}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="button"
                                    className="px-3 py-1 text-white bg-blue-600 rounded-md hover:bg-blue-700"
                                    onClick={_confirmCrop}
                                >
                                    Confirmar
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export const DateInput = ({ type, name, label, error, className, defaultValue = '', information = '', ...rest }) => {
    return (
        <div className={`mt-1 pl-2 pr-2 ${className ? className : 'w-full'}`}>
            <Field name={name}>
                {({
                    field, // { name, value, onChange, onBlur }
                    form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                    meta,
                }) => {
                    field.value = field.value ? Moment.utc(field.value).format('YYYY-MM-DD') : defaultValue;
                    return (
                        <>
                            <label htmlFor={name} className="block">
                                <div className='inline-flex'>
                                    {label}
                                    {information && <BiInfoCircle title={information} size={14} className='mt-1 ml-1 text-blue-700' />}
                                </div>
                            </label>
                            <input
                                {...field}
                                name={name}
                                type={type ?? 'date'}
                                className={`block w-full rounded-md border px-1 py-2 ${meta.touched && meta.error ? 'border-red-500' : ''} ${rest.disabled ? 'bg-gray-300' : ''}`}
                                {...rest}
                            />
                        </>
                    );
                }}
            </Field>
            <ErrorMessage className="text-xs text-red-400" name={name} component="div" />
        </div>
    );
};

export const DateInputBR = ({ type, name, label, error, className, defaultValue = '', information = '', ...rest }) => {
    return (
        <div className={`mt-1 pl-2 pr-2 min-w-fit ${className ? className : 'w-full'}`}>
            <Field name={name}>
                {({
                    field, // { name, value, onChange, onBlur }
                    form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                    meta,
                }) => {
                    return (
                        <div>
                            <label htmlFor={name} className="block">
                                <div className='inline-flex'>
                                    {label}
                                    {information && <BiInfoCircle title={information} size={14} className='mt-1 ml-1 text-blue-700' />}
                                </div>
                            </label>
                            <DatePicker
                                format={{ format: 'DD/MM/YYYY', type: 'mask', }}
                                locale={locale}
                                allowClear={false}
                                onChange={(date, dateString) => setFieldValue(name, date ? date.format('YYYY-MM-DD') : null)}
                                value={field.value && dayjs(field.value).isValid() ? dayjs(field.value) : null}
                                onSelect={(d) => setFieldValue(name, Moment.utc(d).format('YYYY-MM-DD'))}
                                name={name}
                                type={type ?? 'date'}
                                className={`block w-full rounded-md border px-1 py-2 focus-within:outline focus-within:outline-2 focus-within:outline-black focus-within:outline-offset-[-1px] [&_.ant-picker-input>input]:outline-none ${meta.touched && meta.error ? 'border-red-500' : ''} ${rest.disabled ? 'bg-gray-300' : ''}`}
                                {...rest}
                            />
                        </div>
                    );
                }}
            </Field>
            <ErrorMessage className="text-xs text-red-400" name={name} component="div" />
        </div>
    );
};

export const TimeInput = ({ type, name, label, error, className, defaultValue, ...rest }) => {
    return (
        <div className={`mt-1 pl-2 pr-2 ${className ? className : 'w-full'}`}>
            <Field name={name}>
                {({
                    field, // { name, value, onChange, onBlur }
                    form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                    meta,
                }) => {
                    return (
                        <>
                            <label htmlFor={name} className="block">
                                {label}
                            </label>
                            <input
                                name={name}
                                value={field.value}
                                type={type ?? 'time'}
                                className={`block w-full rounded-md border px-1 py-2 ${meta.touched && meta.error ? 'border-red-500' : ''}`}
                                onChange={(e) => {
                                    setFieldValue(name, e.target.value);
                                }}
                            />
                        </>
                    );
                }}
            </Field>
            <ErrorMessage className="text-xs text-red-400" name={name} component="div" />
        </div>
    );
};

export const GroupInput = (props) => {
    return (
        <div className="block">
            <div className={`inline-flex w-full ${props.className}`}>{props.children}</div>
        </div>
    );
};

export const MaskInput = ({ type, name, label, className, mask, value, ...rest }) => {
    return (
        <div className={cn(`mt-1 pl-2 pr-2 w-full`, className)}>
            <label htmlFor={name} className="block">
                {label}
            </label>
            <Field name={name}>
                {({ field, form: { touched, errors }, meta }) => (
                    <InputMask
                        {...field}
                        mask={mask}
                        type={type ?? 'text'}
                        value={field.value || ''}
                        className={`block w-full rounded-md border px-1 py-2 ${meta.touched && meta.error ? 'border-red-500' : ''}`}
                        {...rest}
                    />
                )}
            </Field>
            <ErrorMessage className="text-xs text-red-400" name={name} component="div" />
        </div>
    );
};

export const TextInput = ({ type, name, label, className, rows = 10, cols = 160, mask, information = '', ...rest }) => {
    return (
        <div className={cn(`mt-1 pl-2 pr-2 w-full`, className)}>
            <label htmlFor={name} className="block">
                <div className='inline-flex'>
                    {label}
                    {information && <BiInfoCircle title={information} size={14} className='mt-1 ml-1 text-blue-700' />}
                </div>

            </label>
            <Field name={name}>
                {({ field, form: { touched, errors }, meta }) => (
                    <>
                        <textarea
                            {...field}
                            className={`block w-full rounded-md border px-1 py-1 transition ${meta.touched && meta.error ? 'border-red-500' : ''} ${rest.disabled ? 'bg-gray-300' : ''
                                }`}
                            rows={rows}
                            cols={cols}
                            {...rest}
                        >
                            {field.value}
                        </textarea>
                    </>
                )}
            </Field>
            <ErrorMessage className="text-xs text-red-400" name={name} component="div" />
        </div>
    );
};

export const CepInput = ({ type, name, label, className, value, onReceivedCep, mask = '99999-999', ...rest }) => {
    async function BuscaCep(cep) {
        cep = cep.replace(/\D/g, '');
        if (cep.length === 8) {
            const url = `https://viacep.com.br/ws/${cep}/json/`;
            const response = await axios.get(url);
            if (!response.data?.erro) {
                if (onReceivedCep) onReceivedCep(response.data);
                return true;
            } else {
                return false;
            }
        }
    }
    return (
        <div className={cn(`mt-1 pl-2 pr-2 w-full`, className)}>
            <label htmlFor={name} className="block">
                {label}
            </label>
            <Field name={name}>
                {({ field, form: { touched, errors, setErrors }, meta }) => (
                    <div className="relative inline-flex">
                        <InputMask
                            {...field}
                            type={type ?? 'text'}
                            className={`block w-full rounded-md border px-1 py-2 ${meta.touched && meta.error ? 'border-red-500' : ''}`}
                            mask={mask}
                            value={field.value || ''}
                            {...rest}
                        />
                        <div className="absolute top-3 right-2">
                            <FaSearchLocation
                                className="text-gray-600 cursor-pointer hover:text-black"
                                title="Buscar dados do CEP"
                                onClick={async () => {
                                    let ret = await BuscaCep(field.value);
                                    if (ret === false) {
                                        let nk = {};
                                        nk[name] = 'CEP não encontrado';
                                        setErrors(nk);
                                    }
                                }}
                            />
                        </div>
                    </div>
                )}
            </Field>
            <ErrorMessage className="text-xs text-red-400" name={name} component="div" />
        </div>
    );
};

export const BasicInput = ({ type, name, label, className, value, ...rest }) => {
    return (
        <div className={cn(`mt-1 pl-2 pr-2 w-full`, className)}>
            <label htmlFor={name} className="block">
                {label}
            </label>
            <input type={type ?? 'text'} className={`block w-full rounded-md border px-1 py-2 `} value={value || ''} {...rest} />
            <ErrorMessage className="text-xs text-red-400" name={name} component="div" />
        </div>
    );
};

export const CheckBoxInput = ({ type, name, label, className, value, title, checkedValue = true, uncheckedValue = false, information = '', ...rest }) => {
    return (
        <div className={cn(`mt-1 pl-2 pr-2 w-full`, className)} title={title}>
            <div className="inline-flex">
                <Field name={name}>
                    {({ field, form: { touched, errors, setErrors, setFieldValue, initialValues }, meta }) => (
                        <div className="inline-flex" onClick={() => {
                            setFieldValue(name, field.value === checkedValue ? uncheckedValue : checkedValue);
                        }} >
                            <label htmlFor={name} className={`block ${rest.disabled ? 'text-gray-400' : ''} cursor-pointer`}>
                                <input
                                    value={value}
                                    type="checkbox"
                                    className={`mr-2 `}
                                    {...rest}
                                    checked={field.value === checkedValue}
                                    onChange={(e) => {
                                        //setFieldValue(name, e.target.checked ? checkedValue : uncheckedValue);
                                        e.stopPropagation();
                                    }}
                                />
                                <div className='inline-flex'>
                                    {label}
                                    {information && <BiInfoCircle title={information} size={14} className='mt-1 ml-1 text-blue-700' />}
                                </div>
                            </label>
                            <ErrorMessage className="text-xs text-red-400" name={name} component="div" />
                        </div>
                    )}
                </Field>
            </div>
        </div>
    );
};

export const SelectInput = ({ type, name, label, className, listOptions = [], defaultValue = '', value, ...rest }) => {

    const options = typeof listOptions === 'function' ? listOptions() : listOptions;

    const internalListOptions = [{ value: '', option: 'Selecione...' }, ...options];
    return (
        <div className={cn(`mt-1 pl-2 pr-2 w-full`, className)}>
            <label htmlFor={name} className="block">
                {label}
            </label>
            <Field name={name}>
                {({ field, form, values, errors, setErrors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                    <select
                        {...field}
                        style={{ display: 'block' }}
                        className={`block w-full rounded-md border px-1 py-2  ${rest.disabled ? 'bg-gray-300' : ''}`}
                        {...rest}
                        value={field.value ?? defaultValue}
                    >
                        {internalListOptions.map((item, index) => (
                            <option key={index} value={item.value}>
                                {item.option ?? item.value}
                            </option>
                        ))}
                    </select>
                )}
            </Field>
            <ErrorMessage className="text-xs text-red-400" name={name} component="div" />
        </div>
    );
};
export const DBSelectInput = ({ displaySelectField, url, returnField = '_id', externalRef, className, ...rest }) => {
    const System = useSystemContext();
    const [listOptions, setListOptions] = useState([]);
    var internalUrl = url ?? '';
    useImperativeHandle(externalRef, () => ({
        changeUrl,
    }));

    const carregarOpcoes = useCallback(async () => {
        try {
            const response = await System.apiGet(internalUrl);
            let opcoesFormatadas = response.data.map((item) => ({
                option: deepRecursiveParseData(item, displaySelectField),
                value: deepRecursiveParseData(item, returnField),
                key: uuid(),
                fullDBitem: item,
            }));
            setListOptions(opcoesFormatadas);
            return opcoesFormatadas;
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            return [];
        }
        // eslint-disable-next-line
    }, [internalUrl, deepRecursiveParseData, displaySelectField, returnField]);

    useEffect(() => {
        carregarOpcoes();
    }, [carregarOpcoes]);

    function changeUrl(newUrl) {
        internalUrl = newUrl;
        carregarOpcoes();
    }

    return (
        <div className={cn(`mt-1 pl-2 pr-2 w-full`, className)}>
            <label htmlFor={rest.name} className="block">
                {rest.label}
            </label>
            <Field name={rest.name}>
                {({ field, form, meta }) => (
                    <>
                        <select
                            {...field}
                            style={{ display: 'block' }}
                            className={`block w-full rounded-md border  px-1 py-2 ${rest.disabled ? 'bg-gray-300' : ''} ${rest.name in form.errors ? 'border-red-500' : ''} `}
                            value={field.value?._id || field.value || ''}
                            {...rest}
                            onChange={(e) => {
                                form.setFieldValue(rest.name, e.target.value);
                                // formato do evento: onChange(option, value, fullDBItem)
                                if (rest.onChange) rest.onChange(e.target.options[e.target.selectedIndex].text, e.target.value, listOptions.find((item) => item.value === e.target.value).fullDBitem);
                            }}
                        >
                            <option value={null} key={uuid()}>
                                Selecione...
                            </option>
                            {listOptions.map((item) => (
                                <option key={item.key} value={item.value}>
                                    {item.option}
                                </option>
                            ))}
                        </select>
                        {rest.name in form.errors ? <div className="text-xs text-red-400">{form.errors[rest.name]}</div> : null}
                    </>
                )
                }
            </Field>
        </div>
    );
};

export const DBMultiSelectInput = ({ displaySelectField, url, returnField = '_id', externalRef, ...rest }) => {
    const System = useSystemContext();
    const [listOptions, setListOptions] = useState([]);
    var internalUrl = url ?? '';
    useImperativeHandle(externalRef, () => ({
        changeUrl,
    }));

    const carregarOpcoes = useCallback(async () => {
        try {
            const response = await System.apiGet(internalUrl);
            let opcoesFormatadas = response.data.map((item) => ({
                label: deepRecursiveParseData(item, displaySelectField),
                value: deepRecursiveParseData(item, returnField),
            }));
            setListOptions(opcoesFormatadas);
            return opcoesFormatadas;
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            return [];
        }
        // eslint-disable-next-line
    }, [internalUrl, deepRecursiveParseData, displaySelectField, returnField]);

    useEffect(() => {
        carregarOpcoes();
    }, [carregarOpcoes]);

    function changeUrl(newUrl) {
        internalUrl = newUrl;
        carregarOpcoes();
    }

    return (
        <div className={cn(`mt-1 pl-2 pr-2 w-full`, rest.className)}>
            <label htmlFor={rest.name} className="block">
                {rest.label}
            </label>
            <Field name={rest.name}>
                {({ field, form, meta }) => (
                    <AsyncSelec
                        {...field}
                        isMulti
                        placeholder="Selecione..."
                        style={{ display: 'block' }}
                        className={`block w-full rounded-md border basic-multi-select px-1 py-2 ${rest.disabled ? 'bg-gray-300' : ''}`}
                        value={field.value || ''}
                        {...rest}
                        onChange={(selectedOption) => {
                            form.setFieldValue(rest.name, selectedOption);
                        }}
                        options={listOptions}
                    />
                )
                }
            </Field>
            <ErrorMessage className="text-xs text-red-400" name={rest.name} component="div" />
        </div>
    );
};


export const FormInput = (props = {}) => {
    const System = useSystemContext();

    const document = props.document;
    const initialValues = props.initialValues ?? {};
    const title = props.title ?? '';
    const validateOnBlur = props.validateOnBlur ?? true;
    const validateOnChange = props.validateOnChange ?? true;
    //const enableReinitialize = props.enableReinitialize ?? true;
    const validationSchema = props.validationSchema ?? null;
    //const onCancel = props.onCancel ?? {};
    const onPost = props.onPost ?? _onPost;
    const onPut = props.onPut ?? function _onPut(values) { };
    const onAfterSave = props.onAfterSave ?? _onAfterSave;
    const AfterLoadData = props.onAfterLoadData ?? _AfterLoadData;
    const onRenderFields = props.onRenderFields ?? {};
    const onPrepareSaveRecord = props.onPrepareSaveRecord ?? _onPrepareSaveRecord;

    const [iValues, setIValues] = useState(initialValues);
    const [onEdit, setOnEdit] = useState(false);
    const FormikRef = useRef(null);

    function _AfterLoadData(data) {
        return data;
    }

    const canEdit = System.isAutoEdit() ? true : props.perms ? System.methods.getUserRule(`alterar${props.perms}`) : typeof props.canEdit === 'boolean' ? props.canEdit : true;

    useEffect(() => {
        GetInicialValues();
        // eslint-disable-next-line
    }, []);
    function displayErrors(errors, touched) {
        if (touched) {
            let lst = Object.keys(errors);
            lst.map((key) => {
                if (errors[key] !== undefined) {
                    System.methods.notificationError(key + ' ' + errors[key]);
                }
                return null;
            });
        }
    }

    function _onAfterSave() { }
    function _onPost() { }

    function _onPrepareSaveRecord(values) {
        if (values.arquivo?.name) {
            let newForm = new FormData();
            for (let key in values) {
                newForm.append(key, values[key]);
            }
            return newForm;
        }
        return values;
    }

    function callCommit() {
        FormikRef.current.handleSubmit();
    }

    async function _commit(values) {
        if (!canEdit) {
            System.methods.notificationError('Usuário sem permissão para alterar dados..');
            return;
        }
        values = await onPrepareSaveRecord(values);
        let resultPost = await Post(values);
        return resultPost;
    }
    return (
        <div>
            <Formik
                key={uuid()}
                innerRef={FormikRef}
                initialValues={iValues}
                validateOnChange={validateOnChange}
                validateOnBlur={validateOnBlur}
                enableReinitialize={true} // {enableReinitialize}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting }) => {
                    setTimeout(async () => {
                        await _commit(values);
                        setSubmitting(false);
                    }, 400);
                }}
            >
                {({ values, errors, setErrors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                    <Form>
                        {title && <div key={uuid()} className="w-full pl-2 font-semibold rounded-t bg-amarelo-eq">{title}</div>}
                        {onRenderFields(setFieldValue, values, callCommit)}
                        <div className="flex justify-end gap-4 pt-4 pb-3 pr-4 mt-4 border-t">
                            <button
                                type="submit"
                                className="w-1/4 h-8 text-black rounded-md shadow-md border-1 bg-botao-primario hover:bg-botao-primario-hover hover:text-gray-100"
                                onClick={() => {
                                    displayErrors(errors, touched);
                                }}
                            >
                                Salvar
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
    async function GetInicialValues() {
        await System.apiGet(document).then(async (response) => {
            if (response?.status === 200) {
                let _data = await AfterLoadData(response.data);
                setOnEdit(true);
                setIValues(_data);
            } else {
                setOnEdit(false);
                setIValues(initialValues);
            }
        });
    }
    async function Post(values) {
        if (onEdit) {
            System.apiPut(document, values)
                .then((response) => {
                    if (response.status === 200) {
                        System.methods.notificationSuccess('Documento atualizado com sucesso!');
                        onPut(values);
                        onAfterSave(values);
                        GetInicialValues();
                    } else {
                        System.methods.notificationError('Erro ao atualizar documento!');
                    }
                    return response.status === 200;
                })
                .catch((error) => {
                    System.methods.notificationError('Erro ao atualizar documento!');
                    console.log(error);
                });
        } else {
            System.apiPost(document, values)
                .then((response) => {
                    if (response.status === 200) {
                        System.methods.notificationSuccess('Documento salvo com sucesso!');
                        onPost(values);
                        onAfterSave(values);
                    } else {
                        System.methods.notificationError('Erro ao salvar documento!');
                    }
                    return response.status === 200;
                })
                .catch((error) => {
                    System.methods.notificationError('Erro ao salvar documento!');
                    console.log(error);
                });
        }
    }
};

export const TabsInput = (props = {}) => {

    // Alterar para usar @headlessui/react
    // npm install @headlessui/react
    // import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react'
    // precisa alterar em todo o sistema para corrigir warning


    const { isAutoEdit } = useSystemContext();
    const hash = window.location.hash.substring(1);
    const guiaDefault = parseInt(hash, 10) || 0;

    // Remove o hash da URL sem modificar a página atual
    if (window.history.pushState) {
        window.history.pushState("", document.title, window.location.pathname + window.location.search);
    }

    return (
        <Tabs {...props} defaultIndex={isAutoEdit() ? 1 : guiaDefault} key={uuid()}>
            {props.children}
        </Tabs>
    );
};
